import { useSelector } from "react-redux";

const useAgeGateRegionKillswitch = () => {
  const mixApiData = useSelector((state) => state.mixapi.data);

  // 0 = feature enabled, 1 = feature disabled (kill)
  const ageRegionKillswitchWeb = mixApiData?.conf?.ageRegionKillswitch?.web;
  const isAgeGatingFeatureEnabled = ageRegionKillswitchWeb === 0;

  const whereAmIKillswitchWeb = mixApiData?.conf?.whereAmIKillswitch?.web;
  const isWhereAmIEnabled = whereAmIKillswitchWeb === 0;

  const prizesTermsAgeGateKillswitchWeb =
    mixApiData?.conf?.prizesTermsAgeGateKillswitch?.web;
  const isPrizesTermsAgeGateEnabled = prizesTermsAgeGateKillswitchWeb === 0;

  return {
    isAgeGatingFeatureEnabled,
    isWhereAmIEnabled,
    isPrizesTermsAgeGateEnabled,
  };
};

export default useAgeGateRegionKillswitch;
